export class FindAllBoardsError {
  public static readonly type = '[Project/Board/List] FindAllBoardsError';
  constructor(public readonly error: Error) {}
}
